export const NAVIGATION_ITEM_CLASS = [
    'flex items-center gap-2 rounded-[8px] p-[10px] my-2 relative w-full text-left text-base',
    'hover:bg-[rgba(255,255,255,0.30)] cursor-pointer transition-colors duration-200',
    "after:content-[''] after:absolute after:-bottom-1 after:left-0",
    'after:w-full after:h-[1px] after:bg-[rgba(255,255,255,0.10)]',
].join(' ');

export const NAVIGATION_LAST_ITEM_CLASS = 'after:content-[none]';
